import { useLingui } from '@lingui/react';
import { formatMoneyFixed } from '@wkda/funnel-utils';
import { CheveronRightIcon } from '@wkda/icons';
import { Button } from '@wkda/styleguide';
import { useCallback, useEffect } from 'react';
import { useCarleadConfiguration } from '../../hooks/useCarleadCreationConfiguration';
import { useCarleadDataLayer } from '../../hooks/useCarleadDataLayer';
import { CustomerComment } from './CustomerComment';
import { useTrackCustomerBanner } from '@wkda/funnel-components';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function BannerContentOnsiteExpired(_ref) {
  let {
    manufacturer,
    price,
    isRiskFree,
    bookingUrl
  } = _ref;
  const {
    i18n: _i18n
  } = useLingui();
  const dataLayer = useCarleadDataLayer();
  const {
    locale
  } = useCarleadConfiguration();
  const carPrice = formatMoneyFixed(locale, price !== null && price !== void 0 ? price : 0);
  const {
    trackShownEvent,
    trackCTAClickEvent,
    getCJTrackingButtonNameByAttr
  } = useTrackCustomerBanner();
  useEffect(() => {
    dataLayer.pushCustomerBannerOpen('on-site-price');
    trackShownEvent('on-site-price');
  }, [dataLayer, trackShownEvent]);
  const handleButtonClick = useCallback(e => {
    const ctaName = getCJTrackingButtonNameByAttr(e.currentTarget);
    if (ctaName) {
      trackCTAClickEvent('on-site-price', ctaName);
    }
  }, [getCJTrackingButtonNameByAttr, trackCTAClickEvent]);
  return /*#__PURE__*/_jsx("div", {
    className: "container onsite-expired-rcb",
    children: /*#__PURE__*/_jsxs("div", {
      className: "row text-center",
      children: [/*#__PURE__*/_jsx("div", {
        className: "d-none d-md-block col-md-3",
        children: /*#__PURE__*/_jsx("div", {
          className: "onsite-expired-rcb__image"
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: "col-md-6 col-sm-12",
        children: [/*#__PURE__*/_jsx("div", {
          className: "onsite-expired-rcb__title",
          children: _i18n._('carleadCreation.onSiteExpiredRCB.weAreInterested', {
            manufacturer
          })
        }), carPrice && !isRiskFree && /*#__PURE__*/_jsxs("div", {
          className: "onsite-expired-rcb__price-wrapper",
          children: [/*#__PURE__*/_jsx("div", {
            className: "onsite-expired-rcb__title onsite-expired-rcb__price-wrapper-title",
            children: _i18n._('carleadCreation.onSiteExpiredRCB.expiredOffer')
          }), /*#__PURE__*/_jsx("div", {
            className: "banner-return-customer__price",
            children: carPrice
          })]
        }), !isRiskFree && /*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsx(Button, {
            "data-cj-tracking-button-name": "view-booking-button",
            component: "a",
            variant: "secondary",
            size: "lg",
            href: bookingUrl,
            onClick: handleButtonClick,
            children: /*#__PURE__*/_jsxs("div", {
              className: "d-flex justify-content-center align-items-center",
              children: [_i18n._('carleadCreation.onSiteExpiredRCB.requestNewOffer'), /*#__PURE__*/_jsx(CheveronRightIcon, {
                className: "ml-2"
              })]
            })
          })
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: "d-none d-md-flex col-md-3 justify-content-center align-items-center",
        children: /*#__PURE__*/_jsx(CustomerComment, {
          title: _i18n._('carleadCreation.onSiteExpiredRCB.soldCars')
        })
      })]
    })
  });
}